import React from 'react';
import { TextCell } from '../../../../components/TableV2/Cell/SpecialCells';
import { CellProps } from '../../../../components/TableV2/Cell/Cell';
import styles from '../../PaymentsReportPage.module.scss';
import classnames from 'classnames';

export const CustomTextCell = ({ classes, ...rest }: CellProps) => {
  return <TextCell classes={classnames(classes, styles.CellNowrap)} {...rest} />;
};
